(function () {
  angular.module('app.widgets.common.language-switcher').component('appLanguageSwitcher', {
    controller,
    templateUrl: 'app/widgets/common/language-switcher/language-switcher.component.html',
  });

  /* @ngInject */
  function controller(_, $scope, $window, locale, SELECTED_LOCALE_KEY, storageUtils) {
    const vm = this;
    _.assign(vm, {
      $onInit,
      setActiveLanguage,
    });

    let selectedLanguage;

    function $onInit() {
      selectedLanguage = locale.getActiveLanguage();

      _.assign(vm, {
        languages: _.filter(
          locale.getSupportedLanguages(),
          (lang) => lang.value === selectedLanguage || !lang.hidden
        ),
        selectedLanguage,
        selectedLanguageLabel: getLanguageLabel(selectedLanguage),
      });
    }

    function getLanguageLabel(code) {
      const lang = _.find(locale.getSupportedLanguages(), {value: code});
      return _.get(lang, 'label');
    }

    function setActiveLanguage(code) {
      if (selectedLanguage && selectedLanguage !== code) {
        vm.selectedLanguageLabel = getLanguageLabel(code);
        storageUtils.setLocalStorageItem(SELECTED_LOCALE_KEY, code);
        // If a query param is set, delete it.
        if (locale.getQueryParam()) {
          locale.deleteQueryParam();
          $scope.$on('$locationChangeSuccess', () => {
            $window.location.reload(true); // force reload from server
          });
        } else {
          // We have to reload the whole page when we change locale.
          // Without forcedReload param, the browser may choose to reload from cache.
          $window.location.reload();
        }
      }
    }
  }
})();
